import {DrupalNode} from "next-drupal";

// Convert date to UTC
const toUTCDate = (dateString: string): Date => {
  const date = new Date(dateString);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

export function getEventDateLabel(node?: DrupalNode, locale?: string|undefined, short?: boolean): string {
  if (!node?.field_event_start_date) return "";
  let dateLabel;
  let startDate;
  let endDate;

  /**
   * Helper to get the ordinal.
   *
   * @param number
   * @param locale
   */
  const getOrdinal = (number: string, locale?: string) => {
    let ordinal = "";
    if (locale === "en") {
      if (number === "1" || (number.endsWith("1") && !number.startsWith("1"))) ordinal = "st";
      else if (number === "2" || (number.endsWith("2") && !number.startsWith("1"))) ordinal = "nd";
      else if (number === "3" || (number.endsWith("3") && !number.startsWith("1"))) ordinal = "rd";
      else ordinal = "th";
    }
    return ordinal;
  }

  startDate = toUTCDate(node?.field_event_start_date);
  if (short) {
    const startDay = startDate.toLocaleString(locale, {day: "numeric"});
    const startMonth = startDate.toLocaleString(locale, {month: "long"});
    if (locale === "en") {
      dateLabel = [
        startMonth,
        `${startDay}${getOrdinal(startDay, locale)}`,
      ].join(" ");
    }
    else {
      dateLabel = [
        `${startDay}${getOrdinal(startDay, locale)}`,
      ].join(" ");
    }

    if (node?.field_event_end_date) {
      endDate = toUTCDate(node?.field_event_end_date);
      const endDay = endDate.toLocaleString(locale, {day: "numeric"});
      const endMonth = endDate.toLocaleString(locale, {month: "long"});
      if (endMonth !== startMonth) {
        dateLabel += " - " + endMonth + ` ${endDay}${getOrdinal(endDay, locale)}`;
      }
      else {
        dateLabel += " - " + `${endDay}${getOrdinal(endDay, locale)}`;
      }
    }

    if (locale !== "en") {
      dateLabel += ` ${startMonth}`;
    }
  }
  else {
    if (locale === "en") {
      dateLabel = [
        startDate.toLocaleString(locale, {month: "long"}),
        startDate.toLocaleString(locale, {day: "2-digit"}),
      ].join(" ");
    }
    else {
      dateLabel = [
        startDate.toLocaleString(locale, {day: "2-digit"}),
        startDate.toLocaleString(locale, {month: "long"}),
      ].join(" ");
    }
    if (node?.field_event_end_date) {
      endDate = toUTCDate(node?.field_event_end_date);
      dateLabel += " - " + endDate.toLocaleString(locale, {month: "long", day: "2-digit"});
    }
  }
  return dateLabel;
}
